export const FAQ_LINK = 'https://support.singular.net/hc/en-us/articles/206975446-Goal-Management-FAQ';

export const TRANSLATION_KEY = 'STATIC.PAGES.GOALS';

export const MAX_ENTRIES = 150;

// Sub-goal values persist into Goal.value, a signed 32-bit IntegerField.
export const MAX_ENTRY_VALUE = 2147483647;

export const TOTAL_BUDGET_ENTRY_LABEL = 'Total Budget';

export const GOAL_METRIC = 'cost';
export const GOAL_CONDITION = 'less';
export const GOAL_SCOPE = 'Entire Period';

export const SHELF_MODES = {
    CREATE: 'create',
    EDIT: 'edit',
    DUPLICATE: 'duplicate',
};

export const GOAL_STATUSES = {
    ACTIVE: 'active',
    UPCOMING: 'upcoming',
    ENDED: 'ended',
};

export const SAVE_ACTIONS = {
    CREATED: 'created',
    SAVED: 'saved',
    DELETED: 'deleted',
};

export const SEARCH_VISIBILITY_THRESHOLD = 5;

export const DUPLICATE_NAME_PREFIX = 'Copy of ';
